import React from 'react';
import { reduxWrapper } from '@common/redux/store';
import {
  loadRecommendationsForPlacesEvents,
  loadRecommendationsForPlacesPlaces,
  loadRecommendationsForPlacesStreams
} from '@common/redux/slices/recommendation.slice';
import { NotFoundPage } from '@kursk/components/pages/404/NotFoundPage';
import { SinglePlace } from "@kursk/components/pages/SinglePlace/SinglePlace";
import { loadPlace } from "@common/redux/slices/places.slice";
import { placePageProps } from "@kursk/utils/entitiesPages";
import { loadFeedbacks } from "@common/redux/slices/feedbacks.slice";

export default function page({ notFound }) {

  if (notFound) {
    return (<NotFoundPage/>);
  }
  return (
    <SinglePlace />
  );
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, params, req }) => {
  const { id } = params;
  await Promise.all([
    store.dispatch<any>(loadPlace({ _id: id })),
    store.dispatch<any>(loadRecommendationsForPlacesEvents({ _id: id })),
    store.dispatch<any>(loadRecommendationsForPlacesStreams({ _id: id })),
    store.dispatch<any>(loadRecommendationsForPlacesPlaces({ _id: id })),
    store.dispatch<any>(loadFeedbacks({ type: 'place', placeId: Number(id) })),
  ]);
  const place = store.getState().placesList?.place;
  return placePageProps(place, req)
});
